import { validEmail, validPhone } from "@origin-digital/validation";
import content from "../consts/content.json";

export const validateName = (name: string = ""): string | void => {
  const nameRegex = /^[a-zA-Z ,.'-]+$/;
  if (!name) {
    return content.validationErrors.nameEmptyValidation;
  }

  if (!nameRegex.test(name)) {
    return content.validationErrors.nameInvalidValidation;
  }
};

export const validateEmail = (email: string = ""): string | void => {
  if (!email) {
    return content.validationErrors.emailEmptyValidation;
  }
  return validEmail({ error: content.validationErrors.emailInvalidValidation })(
    email
  );
};

export const validatePhone = (mobile: string = ""): string | void => {
  if (!mobile) {
    return content.validationErrors.phoneEmptyValidation;
  }
  return validPhone({
    error: content.validationErrors.phoneInvalidValidation,
  })(mobile);
};

export const validatePayload = ({
  firstName,
  lastName,
  email,
  phone,
}: {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}) => ({
  firstNameError: validateName(firstName) || undefined,
  lastNameError: validateName(lastName) || undefined,
  emailError: validateEmail(email) || undefined,
  phoneError: validatePhone(phone) || undefined,
});
